(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["birthday-sale-live-popup"]) return;
  try {
    
  birthdaySalePopupInit:{
    const root=document.getElementById('birthdaySalePopup');
    if(!root){break birthdaySalePopupInit;}
    const params=new URLSearchParams(location.search);
    const forced=params.get('birthday_popup')==='1';
    const endRaw=root.dataset.end.trim();
    const parsedDelay=Number.parseInt(root.dataset.delay,10);
    const parsedScrollPercent=Number.parseInt(root.dataset.scroll,10);
    const cfg={
      launch:Date.parse(root.dataset.launch),
      end:endRaw?Date.parse(endRaw):null,
      delay:Number.isFinite(parsedDelay)?Math.max(0,parsedDelay):0,
      scrollPercent:Number.isFinite(parsedScrollPercent)?parsedScrollPercent:0,
      exitIntent:root.dataset.exit==='true',
      frequencyDays:parseInt(root.dataset.frequencyDays,10)||7,
      store:root.dataset.store,
      defaultCountry:root.dataset.country,
      company:root.dataset.company,
      list:root.dataset.list,
      masterList:root.dataset.masterList,
      destination:root.dataset.destination
    };
    const preview=forced;
    const completedKey='hsc_birthday4_popup_completed_20260927';
    const emailSavedKey='hsc_birthday4_popup_email_saved_20260927';
    const dismissedKey='hsc_birthday4_popup_dismissed_20260927';
    const oldSignupKeys=['hsc_sb_done','hsc_sb_email_saved'];
    const endpoint='https://a.klaviyo.com/client/subscriptions/';
    const revision='2025-07-15';
    const source='4th Birthday Sale live popup';

    if(Number.isNaN(cfg.launch)){throw new Error('[birthday-sale-popup] launch date is invalid');}
    if(cfg.end!==null&&Number.isNaN(cfg.end)){throw new Error('[birthday-sale-popup] offer end date is invalid');}
    if(cfg.end!==null&&cfg.end<=cfg.launch){throw new Error('[birthday-sale-popup] offer end must be later than launch');}
    if(cfg.store!=='au'&&cfg.store!=='us'){throw new Error('[birthday-sale-popup] store must be au or us');}
    if(!cfg.company||!cfg.list||!cfg.masterList||cfg.list===cfg.masterList){throw new Error('[birthday-sale-popup] Klaviyo company, Birthday list and distinct master list are required');}

    function storage(kind){
      try{return window[kind];}
      catch(error){console.warn('[birthday-sale-popup] '+kind+' unavailable',error);return null;}
    }
    function storageRead(kind,key){
      const target=storage(kind);if(!target){return null;}
      try{return target.getItem(key);}
      catch(error){console.warn('[birthday-sale-popup] '+kind+' read failed',error);return null;}
    }
    function storageWrite(kind,key,value){
      const target=storage(kind);if(!target){return false;}
      try{target.setItem(key,value);return true;}
      catch(error){console.warn('[birthday-sale-popup] '+kind+' write failed',error);return false;}
    }
    function localRead(key){return storageRead('localStorage',key);}
    function localWrite(key,value){return storageWrite('localStorage',key,value);}
    function phaseAt(now){
      if(preview){return 'live';}
      if(now<cfg.launch){return 'before';}
      if(cfg.end!==null&&now>=cfg.end){return 'closed';}
      return 'live';
    }
    function identifiedKlaviyoVisitor(){
      if(params.has('_kx')){return true;}
      const match=document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if(!match){return false;}
      try{const value=JSON.parse(atob(decodeURIComponent(match[1])));return !!(value.$exchange_id||value.$email);}
      catch(error){console.warn('[birthday-sale-popup] malformed __kla_id cookie ignored',error);return false;}
    }
    function dismissedRecently(){
      const timestamp=parseInt(localRead(dismissedKey),10);
      return Number.isFinite(timestamp)&&(Date.now()-timestamp)<cfg.frequencyDays*86400000;
    }
    function knownVisitor(){
      if(localRead(completedKey)==='1'||localRead(emailSavedKey)==='1'){return true;}
      // 27 Sep 2026: known Klaviyo subscribers and RSVP sign-ups see it too.
      return false;
    }
    function suppressed(){return !preview&&(knownVisitor()||dismissedRecently());}
    function visible(element){return !!(element&&element.getBoundingClientRect().width&&element.getBoundingClientRect().height);}
    function chatInUse(){try{if(document.documentElement.classList.contains('hs-chat-active')||(window.HSSignal&&window.HSSignal.chatActive))return true;const at=Number(localStorage.getItem('hsc_chat_active_at'))||0;return Date.now()-at<30*60000;}catch(e){return document.documentElement.classList.contains('hs-chat-active');}}
    function blockingDialogVisible(){return visible(document.querySelector('#hsc-geo.is-visible'))||visible(document.querySelector('#sbPop.is-open:not([hidden])'));}
    function validEmail(value){return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);}
    function titleCase(value){return value.charAt(0).toUpperCase()+value.slice(1);}

    const sheet=root.querySelector('.birthday-popup__sheet');
    const closeButton=root.querySelector('[data-birthday-popup-close]');
    const eyebrow=root.querySelector('[data-birthday-popup-eyebrow]');
    const headline=root.querySelector('[data-birthday-popup-headline]');
    const subline=root.querySelector('[data-birthday-popup-subline]');
    const detailsForm=root.querySelector('[data-birthday-popup-step="details"]');
    const mobileForm=root.querySelector('[data-birthday-popup-step="mobile"]');
    const dialSelect=root.querySelector('[data-birthday-popup-dial]');
    let opened=false;
    let activePhase='';
    let previousFocus=null;
    let previousOverflow='';
    let pendingTrigger='';
    let blockerObserver=null;
    let state={first:'',email:'',saving:false};

    const countryDials='AF:93,AX:358,AL:355,DZ:213,AS:1,AD:376,AO:244,AI:1,AG:1,AR:54,AM:374,AW:297,AC:247,AU:61,AT:43,AZ:994,BS:1,BH:973,BD:880,BB:1,BY:375,BE:32,BZ:501,BJ:229,BM:1,BT:975,BO:591,BA:387,BW:267,BR:55,IO:246,VG:1,BN:673,BG:359,BF:226,BI:257,KH:855,CM:237,CA:1,CV:238,BQ:599,KY:1,CF:236,TD:235,CL:56,CN:86,CX:61,CC:61,CO:57,KM:269,CG:242,CD:243,CK:682,CR:506,CI:225,HR:385,CU:53,CW:599,CY:357,CZ:420,DK:45,DJ:253,DM:1,DO:1,EC:593,EG:20,SV:503,GQ:240,ER:291,EE:372,SZ:268,ET:251,FK:500,FO:298,FJ:679,FI:358,FR:33,GF:594,PF:689,GA:241,GM:220,GE:995,DE:49,GH:233,GI:350,GR:30,GL:299,GD:1,GP:590,GU:1,GT:502,GG:44,GN:224,GW:245,GY:592,HT:509,HN:504,HK:852,HU:36,IS:354,IN:91,ID:62,IR:98,IQ:964,IE:353,IM:44,IL:972,IT:39,JM:1,JP:81,JE:44,JO:962,KZ:7,KE:254,KI:686,XK:383,KW:965,KG:996,LA:856,LV:371,LB:961,LS:266,LR:231,LY:218,LI:423,LT:370,LU:352,MO:853,MG:261,MW:265,MY:60,MV:960,ML:223,MT:356,MH:692,MQ:596,MR:222,MU:230,YT:262,MX:52,FM:691,MD:373,MC:377,MN:976,ME:382,MS:1,MA:212,MZ:258,MM:95,NA:264,NR:674,NP:977,NL:31,NC:687,NZ:64,NI:505,NE:227,NG:234,NU:683,NF:672,KP:850,MK:389,MP:1,NO:47,OM:968,PK:92,PW:680,PS:970,PA:507,PG:675,PY:595,PE:51,PH:63,PL:48,PT:351,PR:1,QA:974,RE:262,RO:40,RU:7,RW:250,WS:685,SM:378,ST:239,SA:966,SN:221,RS:381,SC:248,SL:232,SG:65,SX:1,SK:421,SI:386,SB:677,SO:252,ZA:27,KR:82,SS:211,ES:34,LK:94,BL:590,SH:290,KN:1,LC:1,MF:590,PM:508,VC:1,SD:249,SR:597,SJ:47,SE:46,CH:41,SY:963,TW:886,TJ:992,TZ:255,TH:66,TL:670,TG:228,TK:690,TO:676,TT:1,TN:216,TR:90,TM:993,TC:1,TV:688,VI:1,UG:256,UA:380,AE:971,GB:44,US:1,UY:598,UZ:998,VU:678,VA:39,VE:58,VN:84,WF:681,EH:212,YE:967,ZM:260,ZW:263'.split(',').map(function(item){const parts=item.split(':');return{country:parts[0],dial:'+'+parts[1]};});
    countryDials.forEach(function(entry){
      const option=document.createElement('option');
      option.value=entry.dial;option.dataset.country=entry.country;option.textContent=entry.country+' '+entry.dial;
      option.selected=entry.country===cfg.defaultCountry;dialSelect.appendChild(option);
    });
    if(dialSelect.selectedIndex<0){
      const fallback=countryDials.findIndex(function(entry){return entry.country===(cfg.store==='us'?'US':'AU');});
      dialSelect.selectedIndex=Math.max(0,fallback);
    }
    function selectedDial(){const option=dialSelect.options[dialSelect.selectedIndex];return{country:option.dataset.country,dial:option.value};}
    function normalizeMobileDisplay(raw){
      let digits=String(raw==null?'':raw).replace(/\D/g,'');
      const dial=selectedDial().dial.slice(1);
      if(digits.indexOf('00')===0){digits=digits.slice(2);}
      if(digits.indexOf(dial)===0&&digits.length-dial.length>=7){digits=digits.slice(dial.length);}
      digits=digits.replace(/^0+/,'');
      return digits.slice(0,15-dial.length);
    }
    function toE164(raw){
      const source=String(raw==null?'':raw).trim();
      let digits=source.replace(/\D/g,'');
      const dial=selectedDial().dial;
      const countryCode=dial.slice(1);
      if(!digits){return null;}
      if(digits.indexOf('00')===0){digits=digits.slice(2);}
      if(digits.indexOf(countryCode)===0&&digits.length-countryCode.length>=7){digits=digits.slice(countryCode.length);}
      digits=digits.replace(/^0+/,'');
      const e164=dial+digits;
      return /^\+[1-9]\d{7,14}$/.test(e164)?e164:null;
    }

    function setError(form,message){
      const error=form.querySelector('[data-birthday-popup-error]');
      error.textContent=message==null?'':message;error.hidden=!message;
    }
    function setBusy(form,busy,label){
      const button=form.querySelector('button[type="submit"]');
      button.disabled=busy;
      if(busy){button.dataset.label=button.textContent;button.textContent=label;}
      else{button.textContent=button.dataset.label||button.textContent;}
    }
    function showStep(step){
      const mobile=step==='mobile';
      detailsForm.hidden=mobile;mobileForm.hidden=!mobile;
      root.classList.toggle('is-step-two',mobile);
      root.setAttribute('aria-labelledby',mobile?'birthdaySalePopupMobileHeading':'birthdaySalePopupHeading');
      sheet.scrollTop=0;
      const focusTarget=mobile?mobileForm.querySelector('input[name="phone"]'):detailsForm.querySelector('input[name="first_name"]');
      if(root.classList.contains('is-open')){focusTarget.focus({preventScroll:true});}
    }
    function applyOffer(){
      activePhase='30_percent';root.dataset.phase='live';
      eyebrow.textContent=root.dataset.eyebrow;
      headline.textContent=root.dataset.headline;
      subline.textContent=root.dataset.subline;
    }
    function emit(name,data){
      const payload=Object.assign({event:name,popup:'birthday-sale-live',store:cfg.store,offer_phase:activePhase},data==null?{}:data);
      if(!Array.isArray(window.dataLayer)){window.dataLayer=[];}
      window.dataLayer.push(payload);
      if(window.Shopify&&Shopify.analytics&&typeof Shopify.analytics.publish==='function'){Shopify.analytics.publish(name,payload);}
    }
    function subscribeToList(listId,profile){
      const controller=typeof AbortController==='function'?new AbortController():null;
      const timeout=controller?window.setTimeout(function(){controller.abort();},12000):null;
      const request={
        method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':revision},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:source,profile:{data:{type:'profile',attributes:profile}}},relationships:{list:{data:{type:'list',id:listId}}}}})
      };
      if(controller){request.signal=controller.signal;}
      return fetch(endpoint+'?company_id='+encodeURIComponent(cfg.company),request).then(function(response){
        if(timeout){window.clearTimeout(timeout);}
        const partial=response.headers.get('X-Klaviyo-Partial-Failure');
        if(partial){const error=new Error('Klaviyo partial failure');error.code=partial.indexOf('phone_number')!==-1?'phone_number':'partial_failure';error.detail=partial.slice(0,300);throw error;}
        if(!response.ok){const error=new Error('Klaviyo '+response.status);error.status=response.status;throw error;}
        return response;
      },function(error){if(timeout){window.clearTimeout(timeout);}throw error;});
    }
    function subscribeProfileToLists(profile){
      return Promise.all([cfg.list,cfg.masterList].map(function(listId){return subscribeToList(listId,profile);}));
    }
    function subscribeEmailProfile(){
      return subscribeProfileToLists({
        email:state.email,first_name:state.first,
        properties:{birthday_popup_phase:activePhase,rsvp_source:source},
        subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}
      });
    }
    function subscribeCompleteProfile(phone,dogName){
      const profile={
        email:state.email,first_name:state.first,phone_number:phone,
        properties:{'Dogs name':dogName,birthday_popup_phase:activePhase,rsvp_source:source},
        subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}},sms:{marketing:{consent:'SUBSCRIBED'}}}
      };
      return subscribeProfileToLists(profile);
    }

    function open(){
      const phase=phaseAt(Date.now());
      if(opened||phase==='before'||phase==='closed'||suppressed()){return;}
      opened=true;previousFocus=document.activeElement;previousOverflow=document.documentElement.style.overflow;
      applyOffer();showStep('details');
      root.hidden=false;root.classList.add('is-open');document.documentElement.classList.add('birthday-popup-open');document.documentElement.style.overflow='hidden';
      closeButton.focus({preventScroll:true});
      emit('birthday_sale_popup_impression');
    }
    function close(reason){
      if(!root.classList.contains('is-open')){return;}
      root.classList.remove('is-open');root.hidden=true;
      document.documentElement.classList.remove('birthday-popup-open');document.documentElement.style.overflow=previousOverflow;
      if(reason==='dismiss'&&!preview){localWrite(dismissedKey,String(Date.now()));emit('birthday_sale_popup_dismiss');}
      if(previousFocus&&previousFocus.isConnected&&typeof previousFocus.focus==='function'){previousFocus.focus({preventScroll:true});}
    }
    // hsc_birthday_cutoff_autoclose_v1: close an already-open sale popup at end_iso.
    let endTimer=null;
    function enforceCutoff(){
      if(preview||cfg.end===null){return;}
      if(endTimer!==null){window.clearTimeout(endTimer);endTimer=null;}
      const remaining=cfg.end-Date.now();
      if(remaining<=0){
        if(blockerObserver){blockerObserver.disconnect();blockerObserver=null;}
        close('cutoff');
        return;
      }
      endTimer=window.setTimeout(enforceCutoff,Math.min(remaining,2147483000));
    }
    function requestOpen(trigger){
      const phase=phaseAt(Date.now());
      if(opened||phase==='before'||phase==='closed'||suppressed()){return;}
      // Never mid-chat (Tom, 25 Oct 2026): the Signal chat sets one flag while it is open or was used in the last 30 minutes;
      // the popup waits for a later page instead of covering the conversation.
      if(chatInUse()){return;}
      if(!blockingDialogVisible()){open();return;}
      pendingTrigger=pendingTrigger||trigger;
      if(blockerObserver){return;}
      blockerObserver=new MutationObserver(function(){
        if(blockingDialogVisible()){return;}
        blockerObserver.disconnect();blockerObserver=null;
        window.requestAnimationFrame(function(){requestOpen(pendingTrigger);});
      });
      blockerObserver.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','hidden','aria-hidden']});
    }
    function startTriggers(){
      const phase=phaseAt(Date.now());
      if(opened||phase==='before'||phase==='closed'||suppressed()){return;}
      window.setTimeout(function(){requestOpen('delay');},cfg.delay*1000);
      if(cfg.scrollPercent>0){
        const onScroll=function(){
          const page=document.documentElement;const maximum=page.scrollHeight-window.innerHeight;
          if(maximum>0&&(window.scrollY/maximum)*100>=cfg.scrollPercent){window.removeEventListener('scroll',onScroll);requestOpen('scroll');}
        };
        window.addEventListener('scroll',onScroll,{passive:true});
      }
      if(cfg.exitIntent&&window.matchMedia('(min-width:768px) and (pointer:fine)').matches){
        const onExit=function(event){if(!event.relatedTarget&&event.clientY<=0){document.removeEventListener('mouseout',onExit);requestOpen('exit');}};
        document.addEventListener('mouseout',onExit);
      }
    }

    detailsForm.addEventListener('submit',function(event){
      event.preventDefault();if(state.saving){return;}
      const first=detailsForm.first_name.value.trim();const email=detailsForm.email.value.trim().toLowerCase();
      if(first.length<2){setError(detailsForm,'Enter your first name.');detailsForm.first_name.focus();return;}
      if(!validEmail(email)){setError(detailsForm,'Check your email and try again.');detailsForm.email.focus();return;}
      setError(detailsForm,'');state.first=first;state.email=email;
      if(preview){showStep('mobile');return;}
      state.saving=true;setBusy(detailsForm,true,'Saving email…');
      subscribeEmailProfile().then(function(){
        localWrite(emailSavedKey,'1');
        if(window.klaviyo&&typeof window.klaviyo.push==='function'){window.klaviyo.push(['identify',{email:state.email,first_name:state.first}]);}
        emit('birthday_sale_popup_email_signup',{email_consent:true,sms_consent:false});
        state.saving=false;setBusy(detailsForm,false);showStep('mobile');
      }).catch(function(error){
        state.saving=false;setBusy(detailsForm,false);
        setError(detailsForm,'That didn’t save. Check your email and try again.');
        console.error('[birthday-sale-popup] email signup failed',error);
        emit('birthday_sale_popup_error',{stage:'klaviyo_email',status:Number.isFinite(error&&error.status)?error.status:0});
      });
    });
    mobileForm.phone.addEventListener('input',function(){
      const normalized=normalizeMobileDisplay(mobileForm.phone.value);
      if(normalized!==mobileForm.phone.value){mobileForm.phone.value=normalized;}
    });
    dialSelect.addEventListener('change',function(){mobileForm.phone.value='';setError(mobileForm,'');mobileForm.phone.focus();});
    mobileForm.addEventListener('submit',function(event){
      event.preventDefault();if(state.saving){return;}
      if(!state.email||!state.first){setError(detailsForm,'Start with your name and email.');showStep('details');return;}
      const phone=toE164(mobileForm.phone.value);const dog=mobileForm.dog_name.value.trim();
      if(!phone){setError(mobileForm,'That mobile doesn’t look right. Check the country code and try again.');mobileForm.phone.focus();return;}
      if(dog.length<1){setError(mobileForm,'Enter your dog’s name.');mobileForm.dog_name.focus();return;}
      setError(mobileForm,'');
      if(preview){setError(mobileForm,'Preview mode only. Submissions are safely switched off here.');return;}
      state.saving=true;setBusy(mobileForm,true,'Unlocking…');
      const dogName=titleCase(dog);
      subscribeCompleteProfile(phone,dogName).then(function(){
        localWrite(completedKey,'1');
        if(window.klaviyo&&typeof window.klaviyo.push==='function'){window.klaviyo.push(['identify',{email:state.email,first_name:state.first,phone_number:phone}]);}
        emit('birthday_sale_popup_signup',{phone_country:selectedDial().country,dog_name:true,email_consent:true,sms_consent:true});
        window.location.assign(cfg.destination);
      }).catch(function(error){
        state.saving=false;setBusy(mobileForm,false);
        setError(mobileForm,error&&error.code==='phone_number'?'That mobile couldn’t be verified. Check the country code and try again.':'That didn’t save just now. Give it another go in a second.');
        console.error('[birthday-sale-popup] Klaviyo signup failed',error);
        emit('birthday_sale_popup_error',{stage:'klaviyo',status:Number.isFinite(error&&error.status)?error.status:0});
      });
    });

    root.addEventListener('click',function(event){if(event.target===root){close('dismiss');}});
    closeButton.addEventListener('click',function(){close('dismiss');});
    document.addEventListener('keydown',function(event){
      if(!root.classList.contains('is-open')){return;}
      if(event.key==='Escape'){close('dismiss');return;}
      if(event.key!=='Tab'){return;}
      const focusable=Array.from(sheet.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(element){return !element.hidden&&element.offsetParent!==null;});
      if(!focusable.length){event.preventDefault();sheet.focus();return;}
      const first=focusable[0];const last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });

    if(!preview){
      enforceCutoff();
      document.addEventListener('visibilitychange',function(){if(!document.hidden){enforceCutoff();}});
      window.addEventListener('pageshow',enforceCutoff);
    }

    if(preview){requestOpen('preview');}
    else if(Date.now()<cfg.launch){window.setTimeout(startTriggers,Math.max(0,cfg.launch-Date.now()));}
    else{startTriggers();}
  }

  } catch(e) { console.error(e); }
})();
})();
